/**
 * @generated SignedSource<<dd5cc75f0e1fbc1bb3a989f18a290bac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppChrome$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalTopNavigation">;
  readonly " $fragmentType": "AppChrome";
};
export type AppChrome$key = {
  readonly " $data"?: AppChrome$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppChrome">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppChrome",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "GlobalTopNavigation"
    }
  ],
  "type": "Query"
};

(node as any).hash = "a01fdc4b4ed38f5e0868af242b200391";

export default node;
